import { joinQuotedWithAnd } from '../utils/helpers';
import { unitToString } from './registry';
import { type Unit } from './types';
import { UnitError } from './UnitError';

export class MultipleBaseUnitsError extends UnitError {
  constructor(baseUnits: Array<Unit>) {
    super(
      `Multiple base units found: ${joinQuotedWithAnd(
        baseUnits.map(unitToString)
      )}"`
    );
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MultipleBaseUnitsError);
    }
    Object.setPrototypeOf(this, MultipleBaseUnitsError.prototype);
  }

  static invariant: (b: boolean, baseUnits: Array<Unit>) => asserts b = (
    b,
    baseUnits
  ) => {
    if (!b) {
      throw new MultipleBaseUnitsError(baseUnits);
    }
  };
}
